/**
 * Fortune-wheel glyph for Harry-ism spins.
 */

export function HarryWheelIcon({ className = 'h-4 w-4 shrink-0' }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden
    >
      <circle cx="12" cy="12" r="9" />
      <circle cx="12" cy="12" r="2" fill="currentColor" stroke="none" />
      <path d="M12 3v6M12 15v6M3 12h6M15 12h6" />
      <path d="M5.6 5.6l4.2 4.2M14.2 14.2l4.2 4.2M18.4 5.6l-4.2 4.2M9.8 14.2l-4.2 4.2" />
      <path d="M12 3l1.2 4.5L12 12l-1.2-4.5z" fill="currentColor" stroke="none" opacity="0.35" />
    </svg>
  );
}
